module.exports = __webpack_public_path__ + "img/home-landing-pod-diaper.ee64f7c0.svg";